import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { DELETE, GET, PGET, PUT } from "../../../api/adminApi";
import { CustomSvg } from "../../../utils/CustomSvg";
import MasterDeleteModal from "../Masters/MasterDeleteModal";
import { getDateTime } from "../../../utils/Dates";
import { Lock, Unlock } from "react-feather";
import { formatNumber } from "../../../utils/utilities";

export default function Level() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(
    +localStorage.getItem("currentPageLevels") || 0,
  ); //for numeration and saving currentPage after refresh
  const [deleteModal, setDeleteModal] = useState({
    show: false,
    master: null,
  });
  const paginate = (data) => {
    setCurrentPage(data.selected);
    localStorage.setItem("currentPageLevels", data.selected); //for saving currentPage after refresh
  };

  async function getItems() {
    const data = await PGET("/services/admin/api/level-pageList", true, {
      region: 0,
      page: currentPage,
      size: 10,
    });
    setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
    setItems(data.data);
  }

  async function handleEnable(id) {
    await GET("/services/admin/api/level-enable/" + id);
    getItems();
  }
  async function handleDisable(id) {
    await GET("/services/admin/api/level-disable/" + id);
    getItems();
  }
  useEffect(() => {
    getItems();
  }, [currentPage]);

  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
    >
      <div className="card-header border-0 pt-5">
        <h3
          className="card-title align-items-start flex-column"
          style={{ marginLeft: -15 }}
        >
          <span className="card-label fw-bold fs-3 mb-1">Уровень</span>
        </h3>
        <div
          className="card-toolbar"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-trigger="hover"
          title="Click to add a user"
        >
          <Link
            to="/admin/level/create"
            className="btn btn-sm btn-light-primary"
            data-bs-toggle="modal"
            data-bs-target="#kt_modal_invite_friends"
          >
            <CustomSvg
              path="/icons/duotune/arrows/arr075.svg"
              className="svg-icon-3"
            />
            Добавить новый
          </Link>
        </div>
      </div>
      <div className="px-3 pb-4 pt-2">
        <div style={{ overflow: "auto", maxHeight: "75vh" }}>
          <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
            <thead className="position-sticky top-0 rounded">
              <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th
                  style={{
                    width: "30px",
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopLeftRadius: "8px",
                  }}
                  className="text-white text-center"
                >
                  №
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Названия
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Уровень
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Минимум
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Максимум{" "}
                </th>
                <th
                  className="text-center text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Статус
                </th>
                <th
                  className="text-start text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopRightRadius: "8px",
                  }}
                ></th>
              </tr>
            </thead>
            <tbody style={{ overflowX: "auto" }}>
              {items.map((item, index) => {
                return (
                  <tr key={item.level} className="borderBottom">
                    <td className="text-center">
                      {currentPage === 0
                        ? index + 1
                        : currentPage * 10 + index + 1}
                    </td>
                    <td className="text-start">{item.name}</td>
                    <td className="text-start">{item.level}</td>
                    <td className="text-end">
                      {formatNumber(item.minPoints)}
                    </td>
                    <td className="text-end">
                      {formatNumber(item.maxPoints)}
                    </td>
                    <td className="text-start w-10">
                      <b
                        style={{
                          whiteSpace: "nowrap",
                        }}
                        className={`p-2 badge rounded font-weight-500 d-block ${
                          item.enabled === true
                            ? "badge-success"
                            : item.enabled === false
                              ? "badge-danger"
                              : "badge-primary"
                        }`}
                      >
                        {item.enabled === true ? "Активный" : null}
                        {item.enabled === false ? "Отключен" : null}
                      </b>
                    </td>
                    <td className="text-end">
                      <div
                        className="d-flex "
                        style={{ justifyContent: "flex-end" }}
                      >
                        <Link
                          to={"/admin/level/update/" + item.level}
                          href="#"
                          className="btn btn-icon shadow-sm btn-active-color-primary btn-sm mr-2"
                        >
                          <CustomSvg
                            path="/icons/duotune/art/art005.svg"
                            className="svg-icon-3"
                          />
                        </Link>
                        {item.enabled === false ? (
                          <button
                            onClick={() => handleEnable(item.level)}
                            className="btn btn-icon shadow-sm btn-active-color-primary btn-sm"
                          >
                            <Unlock color={"#189ED3"} size={14} />
                          </button>
                        ) : (
                          <button
                            onClick={() => handleDisable(item.level)}
                            className="btn btn-icon shadow-sm btn-active-color-primary btn-sm"
                          >
                            <Lock color={"#d31818"} size={14} />
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            forcePage={currentPage}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={paginate}
            containerClassName={"pagination"}
            activeClassName={"bg-dark text-white"}
            pageClassName={"page-item box-shadow br-5"}
          />
        )}
      </div>

      {deleteModal.master && (
        <MasterDeleteModal
          deleteModal={deleteModal}
          setDeleteModal={setDeleteModal}
          getItems={getItems}
        />
      )}
    </div>
  );
}
